import { render, staticRenderFns } from "./CardAdd.vue?vue&type=template&id=061ecec4&scoped=true"
import script from "./CardAdd.vue?vue&type=script&lang=js"
export * from "./CardAdd.vue?vue&type=script&lang=js"
import style0 from "./CardAdd.vue?vue&type=style&index=0&id=061ecec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ecec4",
  null
  
)

export default component.exports